import { CHART_CONFIG, RISK_COLORS, RISK_KEYWORDS } from './constants';

// Helper function to format labels for display
export const formatLabel = (text) => {
  const maxCharsPerLine = CHART_CONFIG.LABEL_MAX_CHARS_PER_LINE;
  const words = text.split(' ');
  let lines = [];
  let currentLine = '';

  words.forEach(word => {
    if ((currentLine + ' ' + word).trim().length <= maxCharsPerLine) {
      currentLine = (currentLine + ' ' + word).trim();
    } else {
      if (currentLine) lines.push(currentLine);
      currentLine = word;
    }
  });
  if (currentLine) lines.push(currentLine);

  return lines.join('\n');
};

// Helper function to determine color based on metric label
export const getMetricColor = (label) => {
  const lowerLabel = label.toLowerCase();
  
  if (RISK_KEYWORDS.CRITICAL.some(keyword => lowerLabel.includes(keyword))) {
    return RISK_COLORS.CRITICAL;
  } else if (RISK_KEYWORDS.HIGH.some(keyword => lowerLabel.includes(keyword))) {
    return RISK_COLORS.HIGH;
  } else if (RISK_KEYWORDS.HELP_REQUESTED.some(keyword => lowerLabel.includes(keyword))) {
    return RISK_COLORS.HELP_REQUESTED;
  }
  
  return RISK_COLORS.MONITOR;
};

// Helper function to calculate percentage change
export const calculatePercentageChange = (newValue, oldValue) => {
  if (oldValue === 0) return newValue > 0 ? 100 : 0;
  return Math.round(Math.abs(((newValue - oldValue) / oldValue) * 100));
};

// Helper function to format change display
export const formatChangeDisplay = (newValue, oldValue) => {
  const change = newValue - oldValue;
  const percentChange = calculatePercentageChange(newValue, oldValue);
  const sign = change > 0 ? '+' : '';
  return `${sign}${change} patients (${percentChange}%)`;
};

// Helper function to get change color
export const getChangeColor = (newValue, oldValue) => {
  if (newValue > oldValue) return '#DC2626'; // Red for increase
  if (newValue < oldValue) return '#16A34A'; // Green for decrease
  return '#6B7280'; // Gray for no change
};